import { Plus } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";

const WorkspaceHeader = ({
  handleCreateNew,
}: {
  handleCreateNew: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <div className="mb-6 flex items-center justify-between">
      <h1 className="text-xl font-semibold text-gray-800">{t("workspaces.header.title")}</h1>
      <button
        className="flex items-center gap-2 rounded-md bg-brand-500 px-4 py-2 text-sm text-white hover:bg-brand-600"
        onClick={handleCreateNew}
      >
        <span className="text-base">
          <Plus />
        </span>
        {t("workspaces.header.createNew")}
      </button>
    </div>
  );
};

export default WorkspaceHeader;
